/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AbstractCommand } from '../AbstractCommand';

/**
 * A command used to create a new response definition in a document.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export abstract class NewResponseDefinitionCommand extends AbstractCommand {
    public _newDefinitionName : string;

    public _newDefinitionDescription : string;

    public _defExisted : boolean;

    public constructor(definitionName? : any, example? : any, description? : any) {
        if(((typeof definitionName === 'string') || definitionName === null) && ((example != null) || example === null) && ((typeof description === 'string') || description === null)) {
            let __args = arguments;
            super();
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionDescription===undefined) this._newDefinitionDescription = null;
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionDescription===undefined) this._newDefinitionDescription = null;
            if(this._defExisted===undefined) this._defExisted = false;
            (() => {
                this._newDefinitionName = definitionName;
                this._newDefinitionDescription = description;
            })();
        } else if(definitionName === undefined && example === undefined && description === undefined) {
            let __args = arguments;
            super();
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionDescription===undefined) this._newDefinitionDescription = null;
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionDescription===undefined) this._newDefinitionDescription = null;
            if(this._defExisted===undefined) this._defExisted = false;
        } else throw new Error('invalid overload');
    }
}
NewResponseDefinitionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.NewResponseDefinitionCommand";
NewResponseDefinitionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




